import {useState} from "react";
import PrimeButton from "../PrimeButton";
import {ReactComponent as PlayIcon} from "../../Icons/Play-fill.svg";
import { showVideo } from "../../Utils/Video";
import { getPlayer } from "../../Utils/Api";
import Alert from '@mui/material/Alert';

export default function PlayVideoButton({ awardId, entryId, mediaId, style = {}, ...props }) {
    const [windowOpen, setWindowOpen] = useState(true);
    const [disableButton, setDisableButton] = useState(false);
    async function onPlayVideo(awardId, entryId, mediaId) {
        setDisableButton(true);
        const resp = await getPlayer(awardId, entryId, mediaId);
        console.log("getPlayer", awardId, entryId, mediaId, resp);

        if(resp.data.status === "ERROR") {
            const html = `
                <html><body>
                    <table style=\\"font-family:sans-serif;\\" width=\\"100%\\" height=\\"100%\\">
                        <tr valign=\\"middle\\">
                            <td align=\\"middle\\">
                                <p>${resp.data.errorMessage}</p>
                            </td>
                        </tr>
                    </table>
                </body></html>
            `;

            showVideo('', {
                width: 660,
                height: 500
            }, html);
        }
        else if("size" in resp.data) {
            const isPlayed = showVideo(resp.data.url, {
                ...resp.data.size,
            });
            if(!isPlayed){
                setWindowOpen(false);
            }
            setDisableButton(false);
        }
    }

    return (
        <>
        <PrimeButton 
            icon={<PlayIcon />} 
            text="Play" 
            styles={style} 
            variant="contained" 
            onClick={() => onPlayVideo(awardId, entryId, mediaId)} 
            {...props}
            disabled={disableButton}
        />

            {
                !windowOpen &&
                <Alert variant="filled" severity="warning">Your browser has popups disabled. To view videos in BAFTA View please enable popups. For more information visit <a target="_blank" rel="noreferrer" href={process.env.REACT_APP_HELPSITE_URI}>BAFTA VIEW Help</a></Alert>
            }
        </>
    );
}
